import { createApp } from 'vue'
import App from './App.vue'

import router from './router'
import store from './store'

import SplitInput from 'vue-split-input'
import moment from "moment"
import Datepicker from '@vuepic/vue-datepicker';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import ApiPlugin from './plugins/api'

const app = createApp(App);

app.use(router);
app.use(store);

app.use(ApiPlugin)
app.use(SplitInput)
app.use(moment)
app.use(Toast)

app.component('Datepicker', Datepicker);

moment.locale('ru')

app.mount('#app');
